import api from 'api/api'
import { toast } from 'react-toastify'
import { UPDATE_SORT_WITH_SUBSORTS } from './sorts.actions'

export const SAVE_SUBSORT = '[SUBSORTS] SAVE SUBSORT'
export const TOGGLE_SUBSORT_STATUS = '[SUBSORTS] TOGGLE SUBSORT STATUS'
export const DELETE_SUBSORT = '[SUBSORTS] DELETE SUBSORT'

export function saveSubsortAction(data) {
  const request = api.post(`/subsorts/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_SUBSORT, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_SUBSORT, payload: { saved: true } })
      dispatch({ type: UPDATE_SORT_WITH_SUBSORTS, payload: { data: response.data.sort_with_subsorts } })
    }).catch((error) => {
      console.log(SAVE_SUBSORT, error)
    }).finally(() => {
      dispatch({ type: SAVE_SUBSORT, payload: { saving: false } })
    })
  }
}

export function toggleSubsortStatusAction(subsortId) {
  const request = api.put(`/subsorts/${subsortId}/toggle-status`)
  return (dispatch) => {
    dispatch({ type: TOGGLE_SUBSORT_STATUS, payload: { updating: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: TOGGLE_SUBSORT_STATUS, payload: { updated: true } })
      dispatch({ type: UPDATE_SORT_WITH_SUBSORTS, payload: { data: response.data.sort_with_subsorts } })
    }).catch((error) => {
      console.log(TOGGLE_SUBSORT_STATUS, error)
    }).finally(() => {
      dispatch({ type: TOGGLE_SUBSORT_STATUS, payload: { updating: false } })
    })
  }
}

export function deleteSubsortAction(subsortId) {
  const request = api.delete(`/subsorts/${subsortId}/delete`)
  return (dispatch) => {
    dispatch({ type: DELETE_SUBSORT, payload: { deleting: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: DELETE_SUBSORT, payload: { deleted: true } })
      dispatch({ type: UPDATE_SORT_WITH_SUBSORTS, payload: { data: response.data.sort_with_subsorts } })
    }).catch((error) => {
      console.log(DELETE_SUBSORT, error)
    }).finally(() => {
      dispatch({ type: DELETE_SUBSORT, payload: { deleting: false } })
    })
  }
}